import React, { useCallback, useEffect, useState } from "react";
import { Button, SelectInput, TextInput, useAuth } from "djinn-components";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { supabase } from "../../../utils/initSupabase";
import { errorStyle, labelStyle } from "../../../constants/styles";
interface UpdateProfileInputs {
  name: string;
}
const ProfileEdit = () => {
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const getDefaults = useCallback(() => {
    return {
      name: user?.name,
    };
  }, [user?.name]);

  const {
    handleSubmit,
    formState: { errors },
    control,
    formState,
    reset,
  } = useForm<UpdateProfileInputs>({
    reValidateMode: "onChange",
    defaultValues: getDefaults(),
  });

  useEffect(() => {
    reset(getDefaults());
  }, [getDefaults, reset]);

  const submitForm = async (values: UpdateProfileInputs) => {
    setLoading(true);

    try {
      await supabase.auth.updateUser({
        data: { ...(user?.metadata ?? {}), name: values.name },
      });
      reset({}, { keepValues: true });
      toast("Profile updated!", { type: "success" });
    } catch (error) {
      //   errorParser(error, setError);
      toast("Failed to update profile!", { type: "error" });
    }

    setLoading(false);
  };

  return (
    <>
      <form
        className="w-full p-4 mt-12 h-full flex flex-col justify-between"
        onSubmit={handleSubmit(submitForm)}
      >
        {/* <Prompt
          when={formState.isDirty}
          message="You have unsaved changes are you sure you want to leave?"
        /> */}
        <div className="flex w-full">
          <div className="w-2/4 px-16 py-4 flex-shrink-0 flex-grow-0">
            <div className="mb-6 w-full">
              <label htmlFor="name" className={labelStyle}>
                Name
              </label>

              <Controller
                name="name"
                control={control}
                rules={{
                  required: true,
                }}
                render={({ field: { onChange, value } }) => (
                  <TextInput
                    id="name"
                    placeholder="Enter your name"
                    value={value}
                    onChange={onChange}
                    invalid={!!errors.name}
                  />
                )}
              />

              {errors.name && errors.name.type === "required" && (
                <span className={errorStyle}>Name is required</span>
              )}

              {errors.name && errors.name.type === "api" && (
                <span className={errorStyle}>{errors.name.message}</span>
              )}
            </div>

            <div className="mb-6">
              <label htmlFor="email" className={labelStyle}>
                Email address
              </label>

              <TextInput type="email" value={user?.email} disabled={true} />
            </div>

            <div className="mb-6 w-full">
              <label htmlFor="email" className={labelStyle}>
                Password
              </label>
              <div className="bg-gray-700 rounded-full flex justify-between items-center">
                <div
                  className="p-4 text-sm text-white"
                  style={{
                    fontSize: "37px",
                    letterSpacing: "3px",
                    lineHeight: 0,
                    fontWeight: 800,
                  }}
                >
                  ∙∙∙∙∙∙∙∙∙
                </div>
                <button
                  type="button"
                  className="bg-gray-500 text-center p-4 text-white rounded-r-full text-sm cursor-pointer hover:opacity-75 transition ease-in-out duration-150"
                  onClick={async () => {
                    await supabase.auth.resetPasswordForEmail(
                      user?.email as string
                    );
                    toast(
                      `A password reset email has been sent to ${user?.email}`,
                      { type: "success" }
                    );
                  }}
                >
                  Change
                </button>
              </div>
            </div>

            <div className="mb-6">
              <label htmlFor="timezone" className={labelStyle}>
                Time Zone
              </label>
              <SelectInput
                selected="gmt"
                options={[
                  {
                    value: "gmt",
                    key: "Greenwich Mean Time (GMT)",
                  },
                ]}
              />
            </div>
          </div>
          <div className="w-2/4 flex-shrink-0 flex-grow-0"></div>
        </div>
        <div className="w-full flex justify-end items-center">
          <button
            type="button"
            hidden={!formState.isDirty}
            onClick={() => reset(getDefaults())}
            className="text-sm text-white mr-6 opacity-50 hover:opacity-100 cursor-pointer transition ease-in-out duration-150 focus:outline-none"
          >
            Discard Changes
          </button>
          <div className="w-56">
            <Button
              text="Save Profile"
              loading={loading}
              disabled={loading || !formState.isDirty}
              type="submit"
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default ProfileEdit;
